module.exports = __webpack_public_path__ + "static/media/use12_ch01.96c900ed.png";